'use strict';
import CommonCollection from './CommonCollection';
import * as ConstUtil from '../util/ConstUtil';
import * as LogUtil from '../util/LogUtil';
import CarModel from './model/CarModel';
import _ from 'lodash';
import ConnectionUtil from '../util/ConnectionUtil';

class CarCollection extends CommonCollection {
  constructor() {
    let param = {
      baseModel: CarModel,
      listResponseKey: ConstUtil.Common.API_LIST.carList.LIST_RESPONSE_KEY
    };
    super(param);
  }

  /**
   * 一覧取得
   *
   * @param {Object} api API情報
   * @param {Object} callback コールバック
   * @param {Object} payload ペイロード
   * @memberof CommonCollection
   */
  getCarSelectList(api, callback, payload) {
    let self = this;
    // タイムスタンプを追加
    if (_.isObject(payload)) {
      payload.timestamp = Date.now();
    }
    // リクエストパラメータをセット
    let request = {
      headers: {},
      data: { params: payload }
    };

    // API呼び出し
    ConnectionUtil.callAPI(api, request, function(err, res) {
      if (err) {
        callback.failure(err);
        return;
      }
      self.setCarSelectListResponse(res.data, callback);
      return;
    });
  }

  /**
   * 一覧取得レスポンスデータをセット
   *
   * @param {Object} responseData レスポンスデータ
   * @param {Object} callback コールバック
   * @memberof CommonCollection
   */
  setCarSelectListResponse(responseData, callback) {
    // collection 初期化
    this.reset();
    let models = [];

    this.listResponseKey = 'car_list';
    // チェックする値を渡してvalidation結果を取得
    let collectionValidationErrors = this.extendPreValidate(
      {
        // リスト形式チェック
        [this.listResponseKey]: this.checkListType(
          responseData[this.listResponseKey]
        )
      },
      responseData
    );

    // validationエラーが存在する場合
    if (collectionValidationErrors !== undefined) {
      LogUtil.d('[collectionValidationError]:' + collectionValidationErrors);
      callback.validationError();
      return;
    }

    // list分baseModelを作成し追加する
    for (let data of responseData[this.listResponseKey]) {
      let model = new this.baseModel();
      // チェックする値を渡してvalidation結果を取得
      let modelValidationErrors = model.extendPreValidate(
        model.validation,
        data
      );
      // validationエラーが存在する場合
      if (modelValidationErrors !== undefined) {
        LogUtil.d('[modelValidationError]:' + modelValidationErrors);
        callback.validationError();
        continue;
      }
      // responseData を string型へ変換
      let stringData = this.convertResponseData(data);
      model.setProperties(stringData);
      models.push(model);
    }
    this.add(models);

    // responseDataからresponseを削除
    delete responseData[this.listResponseKey];

    // collection更新
    _.extend(this, responseData);
    callback.success();
  }
}
export default CarCollection;



// WEBPACK FOOTER //
// ./src/js/collection/CarCollection.jsx